import React from "react";
import SideBarNav from "./SideBarNav";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import NotificationAlert from "react-notification-alert";
import {getStates, isPhoneNumber} from "../../modules/utils";
import { connect } from "react-redux";
import {
  updateUserRequest,
  geCurrentUser,
  updateShipping,
  addShipping
} from "../../modules/actions/authActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import PropTypes from "prop-types";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";
//import InputMask from 'react-input-mask';
import MaskedInput from 'react-text-mask'

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.firstname)) {
    errors.firstname = "This field is required";
  }
  if (Validator.isEmpty(data.lastname)) {
    errors.lastname = "This field is required";
  }
  if (!Validator.isEmpty(data.phoneno) && !isPhoneNumber(data.phoneno)) {
    errors.phoneno = "Please enter valid phone number";
  }
  if (Validator.isEmpty(data.email)) {
    errors.email = "This field is required";
  }
  if (!Validator.isEmail(data.email)) {
    errors.email = "Please enter valid Email id";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

function validateAddress(data) {
  let errors = {};
  if (Validator.isEmpty(data.address1)) {
    errors.address1 = "This field is required";
  }

  if (Validator.isEmpty(data.city)) {
    errors.city = "This field is required";
  }
  if (Validator.isEmpty(data.state)) {
    errors.state = "This field is required";
  }
  if (Validator.isEmpty(data.country)) {
    errors.country = "This field is required";
  }
  if (Validator.isEmpty(data.zipcode)) {
    errors.zipcode = "This field is required";
  }

  if (!Validator.isNumeric(data.zipcode)) {
    errors.zipcode = "Enter a number";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class ProfileSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      phoneno: "",
      email: "",
      password: "",
      newpassword: "",
      errors: {},
      successMsg: "",
      userShipping: {
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipcode: "",
        country: "US"
      },
      isLoading: false,
      invalid: false
    };
  }

  componentDidMount() {
    this.props.geCurrentUser();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile) {
      console.log(nextProps.profile);
      if (!nextProps.profile.userShipping) {
        delete nextProps.profile.userShipping;
      }
      this.setState({ ...this.state, ...nextProps.profile });
    }
  }

  // handleProfileUpdate = event => {
  //   event.preventDefault();
  //   if (this.isValid()) {
  //     const { firstname, lastname, email, password } = this.state;

  //     const profile = {
  //       firstname,
  //       lastname,
  //       email,
  //       password
  //     };
  //     this.setState({ errors: {}, isLoading: true });
  //     this.props
  //       .updateUserRequest(profile)
  //       .then(data => {
  //         console.log(data);
  //         if (data.status) {
  //           this.setState({ successMsg: data.message, isLoading: false });
  //         } else {
  //           this.setState({ errors: data, isLoading: false });
  //         }
  //       })
  //       .catch(error => {
  //         console.log(error);
  //         this.setState({ errors: error.response.data, isLoading: false });
  //       });
  //   }
  // };

  handleProfileUpdate = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { firstname, lastname, phoneno, email, password } = this.state;

      const profile = {
        firstname,
        lastname,
        phoneno,
        email,
        password
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
          .updateUserRequest(profile)
          .then(data => {
            console.log(data);
            if (data.status) {
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "success",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            } else {
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            }
          })
          .catch(error => {
            console.log(error);
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                  <div>
                    <div>
                      <b>{error.response.data.message}</b>
                    </div>
                  </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          });
    }
  };

  handleShippingUpdate = event => {
    event.preventDefault();
    if (this.isValidShipping()) {
      const { firstname, lastname } = this.state;
      const {
        address1,
        address2,
        country,
        city,
        state,
        zipcode
      } = this.state.userShipping;

      const shipping = {
        firstname,
        lastname,
        address1,
        address2,
        city,
        state,
        zipcode,
        country
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
          .updateShipping(shipping)
          .then(data => {
            console.log(data);
            if (data.status) {
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "success",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            } else {
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            }
          })
          .catch(error => {
            console.log(error);

            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                  <div>
                    <div>
                      <b>{error.response.data.message}</b>
                    </div>
                  </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          });
    }
  };

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  _onShippingChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({
      userShipping: { ...this.state.userShipping, [field]: value }
    });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  isValidShipping() {
    const { errors, isValid } = validateAddress(this.state.userShipping);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  render() {
    const { isAuthenticated, user } = this.props.auth;

    const address1 = this.state.userShipping.address1
        ? this.state.userShipping.address1
        : "";
    const address2 = this.state.userShipping.address2
        ? this.state.userShipping.address2
        : "";
    const country = this.state.userShipping.country
        ? this.state.userShipping.country
        : "";
    const city = this.state.userShipping.city
        ? this.state.userShipping.city
        : "";
    const state = this.state.userShipping.state
        ? this.state.userShipping.state
        : "";
    const zipcode = this.state.userShipping.zipcode
        ? this.state.userShipping.zipcode
        : "";

    const { errors, successMsg, firstname, lastname, email } = this.state;
    console.log("profile setting state", this.state);
    return (
        <section className="BodyContainer">
          <div className="container">
            <div className="row">
              <SideBarNav />
              <div className="col-lg-8">
                <div className="mt-0">
                  <NotificationAlert ref="notify" />
                  <h4 className="features_title">Profile Settings</h4>

                  <div style={{ clear: "both", height: "15px" }} />

                  <h5 className="bold600 mb-2 SansSerif">Hello, {isAuthenticated ? user.user.profile.name : null}!</h5>
                  You have the ability to view a snapshot of your recent account activity<br/>and update your account information.

                  <div style={{ clear: "both", height: "15px" }} />

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            name="firstname"
                            value={firstname}
                            autoCapitalize="word"
                            className="form-control autocapitalize"
                            onChange={this._onChange}
                            placeholder="First Name"

                        />
                        {errors.firstname && (
                            <span className="error-color-dash">
                          {errors.firstname}
                        </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            name="lastname"
                            className="form-control autocapitalize"
                            value={lastname}
                            onChange={this._onChange}
                            placeholder="Last Name"
                        />
                        {errors.lastname && (
                            <span className="error-color-dash">
                          {errors.lastname}
                        </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3" />
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group mt-3">
                        {/*<InputMask mask="999-999-9999" id="phoneno" name="phoneno" type="text" value={this.state.phoneno} field="phoneno" placeholder="Phone Number" className="form-control" onChange={this._onChange} />*/}
                        <MaskedInput mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]} id="phoneno" name="phoneno" type="text" value={this.state.phoneno} field="phoneno" placeholder="Phone Number" className="form-control" onChange={this._onChange} />
                        {errors.phoneno && (
                            <span className="error-color-dash">{errors.phoneno}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3" />
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            name="email"
                            className="form-control"
                            value={email}
                            onChange={this._onChange}
                            placeholder="Email Address"
                            disabled
                        />
                        {errors.email && (
                            <span className="error-color-dash">{errors.email}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3" />
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group mt-3">
                        <a
                            href="javascript:void(0)"
                            onClick={this.handleProfileUpdate}
                            className="btn btn-custom w-100"
                        >
                          SAVE
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-3" />
                  </div>
                </div>

                <div className="mt-3" style={{ paddingTop: "5%" }}>
                  <strong>ADDRESS INFORMATION</strong>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            name="address1"
                            className="form-control"
                            value={address1}
                            onChange={this._onShippingChange}
                            placeholder="Address Line 1"
                        />
                        {errors.address1 && (
                            <span className="error-color-dash">
                          {errors.address1}
                        </span>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            name="address2"
                            className="form-control"
                            value={address2}
                            onChange={this._onShippingChange}
                            placeholder="Address Line 2"
                        />
                        {errors.address2 && (
                            <span className="error-color-dash">
                          {errors.address2}
                        </span>
                        )}
                      </div>
                    </div>
                    <div style={{ clear: "both" }} />
                    <div className="col-lg-4">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={city}
                            onChange={this._onShippingChange}
                            placeholder="City"
                        />
                        {errors.city && (
                            <span className="error-color-dash">{errors.city}</span>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group mt-3">
                        <select
                            name="state"
                            onChange={this._onShippingChange}
                            className="form-control"
                            value={state}
                        >
                          <option value="">State</option>;
                          {getStates().map(function(state, index) {
                            return (
                                <option key={index} value={state.abbreviation}>
                                  {state.name}
                                </option>
                            );
                          })}
                        </select>

                        {errors.state && (
                            <span className="error-color-dash">{errors.state}</span>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group mt-3">
                        <input
                            type="text"
                            className="form-control"
                            name="zipcode"
                            value={zipcode}
                            onChange={this._onShippingChange}
                            className="form-control"
                            placeholder="ZIP Code"
                        />
                        {errors.zipcode && (
                            <span className="error-color-dash">
                          {errors.zipcode}
                        </span>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group mt-3">
                        <a
                            href="javascript:void(0)"
                            onClick={this.handleShippingUpdate}
                            className="btn btn-custom w-100"
                        >
                          SAVE ADDRESS
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    profile: state.auth.profile
  };
}
export default connect(
    mapStateToProps,
    {
      updateUserRequest,
      geCurrentUser,
      addFlashMessage,
      updateShipping,
      addShipping
    }
)(ProfileSetting);



// WEBPACK FOOTER //
// ./src/pages/dashboard/ProfileSetting.js